webpackJsonp([4],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "08El":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "3Lce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by BaiDX on 17/6/9.
 */
var global = {};

global.sheets = {};
var origin = '';
if (window.location.hostname == 'localhost') {
  //a
  origin = 'http://analyze.msgcopy.com';
} else {
  origin = '';
}
if (window.location.hostname.indexOf('msgcopy.com') > 0 || window.location.hostname == 'localhost' || window.location.hostname.indexOf('maprca-dev') >= 0) {
  global._PROJECT = '';
} else {
  global._PROJECT = 'shdq';
}
if (window.location.hostname.indexOf('shanghai-electric') >= 0 && window.location.hostname.indexOf('maprca-dev') < 0) {
  global._PROJECT = 'shdq';
} else {
  global._PROJECT = '';
}
global.domain = {
  editor: origin + '/editor',
  diy: origin + '/diy',
  bi: origin + '/bi',
  test: origin + '/test',
  www: origin + '/www'
};
global.api = {
  analyze: origin
};
/* harmony default export */ __webpack_exports__["a"] = (global);

/***/ }),

/***/ "4HDC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ACWb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.global._PROJECT!='shdq')?_c('div',{staticClass:"login"},[_c('h1',{staticClass:"logo"},[_vm._v("注册")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"input-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text","placeholder":"请输入用户名"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"second"},[_c('span',{staticClass:"forget",on:{"click":_vm.login}},[_vm._v("前往登录")])]),_vm._v(" "),_c('div',{staticClass:"sub-btn",on:{"click":_vm.register}},[_vm._v("注 册")])]),_vm._v(" "),_c('div',{staticClass:"cut"}),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"des"},[_c('span',[_vm._v("已有账号？")]),_vm._v(" "),_c('span',{staticClass:"register",on:{"click":_vm.login}},[_vm._v("立即登录")])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AJQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("KEc+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_668fc992_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("ACWb");
function injectStyle (ssrContext) {
  __webpack_require__("vUyH")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-668fc992"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_668fc992_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E98f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EHpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pass"},[_c('div',{staticClass:"top"}),_vm._v(" "),_c('div',{staticClass:"bottom"}),_vm._v(" "),_c('router-view',{staticClass:"router"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "How1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("c1Lm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_cc286bf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("d4Tv");
function injectStyle (ssrContext) {
  __webpack_require__("mME3")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc286bf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_cc286bf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IH2Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("QRbf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("HVJf");
/**
 * Created by Volvo on 17/9/7.
 */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
  plugins: []
}));

/***/ }),

/***/ "KEc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      phone: '',
      code: '',
      password: '',
      codeInfo: '获取验证码',
      count: 60
    };
  },

  methods: {
    getCode: function getCode() {
      var self = this;
      if (this.codeInfo != '获取验证码') return;else if (!this.isTel(self.phone)) {
        this.$message.error('手机号格式有误');
        return;
      } else {
        this.codeInfo = '发送中...';
        this.$http({
          method: 'post',
          url: self.global.api.analyze + '/apps/' + self.$route.query.app + '/iapi/misc/smscode/',
          data: self.qs.stringify({ mobile: self.phone }),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          if (response.data == '验证码已发送到手机,请查收!') {
            self.$message.success('验证码已发送到手机');
            self.countDown();
          }
        }, function (error) {
          self.$message.error('手机号已注册');
          self.codeInfo = '获取验证码';
        });
      }
    },
    isTel: function isTel(phone) {
      if (!/^1[34578]\d{9}$/.test(phone)) {
        return false;
      } else {
        return true;
      }
    },
    countDown: function countDown() {
      var self = this;
      this.codeInfo = this.count + '秒后可重发';
      var time = setInterval(function () {
        if (self.count > 0 && self.codeInfo != '获取验证码') {
          self.codeInfo = self.count + '秒后可重发';
          self.count--;
        } else {
          clearInterval(time);
          self.codeInfo = '获取验证码';
          self.count = 60;
        }
      }, 1000);
    },
    register: function register() {
      //        const self = this;
      //        console.log(this.$route);
      //        if(!this.password){
      //            self.$message.error('请输入密码');
      //            return;
      //        }
      //        this.$http({
      //          method: 'GET',
      //          url: self.global.api.analyze + '/iapi/misc/smscode/validation/' + self.phone + '/' + self.code + '/',
      //        }).then(function (response) {
      //          if (response.data != 'OK') {
      //            self.$message.error('验证码有误');
      //            return;
      //          } else {
      //            //注册
      //            self.$http({
      //              method: 'post',
      //              url: self.global.api.analyze + '/iapi/user/register/',
      //              data: self.qs.stringify({
      //                username: self.phone,
      //                password1: self.password,
      //                password2: self.password,
      //                agreement: true
      //              }),
      //              headers: {
      //                'Content-Type': 'application/x-www-form-urlencoded',
      //              }
      //            }).then(response1 => {
      //              self.$http({
      //                method: 'post',
      //                url: self.global.api.analyze + '/iapi/user/login/',
      //                data: self.qs.stringify({'username': self.phone, 'password': self.password}),
      //                headers: {
      //                  'Content-Type': 'application/x-www-form-urlencoded',
      //                }
      //              }).then(function (response2) {
      //                if (self.$route.query.next)
      //                  window.location = self.$route.query.next
      //              }, error => {
      //                self.$message.error('请输入正确的用户名密码')
      //              })
      //            }, error => {
      //              self.$message.error(JSON.stringify(error.data));
      //            })
      //          }
      //        }, error => {
      //          self.$message.error('验证码有误');
      //        });
      var self = this;
      if (!this.password) {
        self.$message.error('请输入密码');
        return;
      }
      if (!self.$route.query.app && !(this.username == 'volvo' || this.username == 'luoxb' || this.username == '13701171932')) {
        self.$message.error('账号不可用');
        return;
      }
      this.$http({
        method: 'post',
        url: (self.$route.query.app ? '/apps/' + self.$route.query.app : '') + '/iapi/user/register/',
        data: self.qs.stringify({
          username: self.username,
          password: self.password
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response1) {
        if (response1.data.code != 0) {
          self.$message.error(response1.data.message);
          return;
        }
        self.$http({
          method: 'post',
          url: (self.$route.query.app ? '/apps/' + self.$route.query.app : '') + '/iapi/user/login/',
          data: self.qs.stringify({ 'username': self.username, 'password': self.password }),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response2) {
          if (self.$route.query.next) window.location = self.$route.query.next;
        }, function (error) {
          self.$message.error('请输入正确的用户名密码');
        });
      }, function (error) {
        self.$message.error(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error.data));
      });
    },
    login: function login() {
      var self = this;
      this.$router.push({ name: 'Login', query: self.$route.query });
    }
  }
});

/***/ }),

/***/ "KL2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LqM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("yfl/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_49a93937_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("nr7V");
function injectStyle (ssrContext) {
  __webpack_require__("4HDC")
  __webpack_require__("IH2Y")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49a93937"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_49a93937_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3e6aced2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("KL2o");
function injectStyle (ssrContext) {
  __webpack_require__("W3pf")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3e6aced2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__("briU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("QRbf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("HVJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("BMa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__("CQ6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global__ = __webpack_require__("3Lce");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_index_js__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("ZAwa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_simple_line_icons_css_simple_line_icons_css__ = __webpack_require__("E98f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_simple_line_icons_css_simple_line_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_simple_line_icons_css_simple_line_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_font_awesome_css_font_awesome_min_css__ = __webpack_require__("uxEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_app_css__ = __webpack_require__("UBJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_app_css__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
var qs = __webpack_require__("cN5t");

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

var aesjs = __webpack_require__("M5pJ");
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.cbc = function (_text) {
  // An example 128-bit key
  var key = aesjs.utils.utf8.toBytes('xrq(1lb*xy#xkr67');

  // The initialization vector (must be 16 bytes)
  var iv = aesjs.utils.utf8.toBytes('r$i5e29o&cip7zyw');

  // Convert text to bytes (text must be a multiple of 16 bytes)
  var text = _text;
  var realLength = 0;
  var len = text.length;
  var charCode = -1;
  for (var i = 0; i < len; i++) {
    charCode = text.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) {
      realLength += 1;
    } else {
      // 如果是中文则长度加2
      realLength += 3;
    }
  }
  // var count = 16-realLength%16;
  // if(count<16){
  //   for (let i=0;i<count;i++){
  //     text+='\x00'
  //   }
  // }
  var textBytes = aesjs.utils.utf8.toBytes(text);
  var count = 16 - textBytes.length % 16;
  if (count < 16) {
    for (var _i = 0; _i < count; _i++) {
      text += '\x00';
    }
  }
  textBytes = aesjs.utils.utf8.toBytes(text);

  var aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
  var encryptedBytes = aesCbc.encrypt(textBytes);

  // To print or store the binary data, you may convert it to hex
  var encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
  return encryptedHex;

  // "104fb073f9a131f2cab49184bb864ca2"

  // // When ready to decrypt the hex string, convert it back to bytes
  //   var encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex);
  //
  // // The cipher-block chaining mode of operation maintains internal
  // // state, so to decrypt a new instance must be instantiated.
  //   var aesCbc = new aesjs.ModeOfOperation.cbc(key, iv);
  //   var decryptedBytes = aesCbc.decrypt(encryptedBytes);
  //
  // // Convert our bytes back into text
  //   var decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
  //   console.log(decryptedText);
  // // "TextMustBe16Byte"
};

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.withCredentials = true; //跨域携带cookie

// 添加请求拦截器
__WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (config.method == 'put' || config.method == 'post') {
    var data = config.data,
        validation = {
      'password': true,
      'new_passwd': true,
      'old_passwd': true,
      'mdx': true,
      'sql': true,
      'db_passwd': true
    };
    if (config.headers['Content-Type'] == 'application/x-www-form-urlencoded') {
      data = qs.parse(config.data);
      for (var i in data) {
        if (validation[i]) {
          data[i] = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.cbc(data[i]);
        }
      }
      if (config.method == 'put') {
        config.method = 'post';
        data['_method'] = 'put';
      }
      config.data = qs.stringify(data);
    } else if (config.headers['Content-Type'] == 'application/json;charset=utf-8' || config.headers['Content-Type'] == 'application/json' || config.headers['Content-Type'] == undefined) {
      data = config.data;
      for (var _i2 in data) {
        if (validation[_i2]) {
          data[_i2] = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.cbc(data[_i2]);
        }
      }
      if (config.method == 'put') {
        config.method = 'post';
        data['_method'] = 'put';
      }
    }
  }
  if (config.method == 'delete') {
    config.method = 'post';
    config.headers['Content-Type'] == 'application/x-www-form-urlencoded';
    config.data = qs.stringify({ '_method': 'delete' });
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.withCredentials = true;
if (false) {
  axios.defaults.baseURL = "/dev-server";
}
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_6_axios___default.a;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.qs = qs;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.bs = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.global = __WEBPACK_IMPORTED_MODULE_8__global__["a" /* default */];

// // 设置默认溢出显示数量
// var spillDataNum = 20;
//
// // 设置隐藏函数
// var timeout = false;
// let setRowDisableNone = function (topNum, showRowNum, binding) {
//   if (timeout) {
//     clearTimeout(timeout);
//   }
//   timeout = setTimeout(() => {
//     binding.value.call(null, topNum, topNum + showRowNum + spillDataNum);
//   });
// };
// Vue.directive('loadmore',{
//   name: 'loadmore',
//   componentUpdated: function (el, binding, vnode, oldVnode) {
//     console.log('dsadsads');
//     setTimeout(() => {
//       const dataSize = vnode.data.attrs['data-size'];
//       const oldDataSize = oldVnode.data.attrs['data-size'];
//       if(dataSize === oldDataSize){
//         return;
//       }
//       const selectWrap = el.querySelector('.el-table__body-wrapper');
//       const selectTbody = selectWrap.querySelector('table tbody');
//       const selectRow = selectWrap.querySelector('table tr');
//       if (!selectRow) {
//         return;
//       }
//       const rowHeight = selectRow.clientHeight;
//       let showRowNum = Math.round(selectWrap.clientHeight / rowHeight);
//
//       const createElementTR = document.createElement('tr');
//       let createElementTRHeight = (dataSize - showRowNum - spillDataNum) * rowHeight;
//       createElementTR.setAttribute('style', `height: ${createElementTRHeight}px;`);
//       selectTbody.append(createElementTR);
//
//       // 监听滚动后事件
//       selectWrap.addEventListener('scroll', function () {
//         let topPx = this.scrollTop - spillDataNum * rowHeight;
//         let topNum = Math.round(topPx / rowHeight);
//         let minTopNum = dataSize - spillDataNum - showRowNum;
//         if (topNum > minTopNum) {
//           topNum = minTopNum;
//         }
//         if (topNum < 0) {
//           topNum = 0;
//           topPx = 0;
//         }
//         selectTbody.setAttribute('style', `transform: translateY(${topPx}px)`);
//         createElementTR.setAttribute('style', `height: ${createElementTRHeight-topPx > 0 ? createElementTRHeight-topPx : 0}px;`);
//         setRowDisableNone(topNum, showRowNum, binding);
//       })
//     });
//   }
// })


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_9__store_index_js__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ "R0Ro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Pass_router_vue__ = __webpack_require__("08El");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_58cc4389_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Pass_router_vue__ = __webpack_require__("EHpm");
function injectStyle (ssrContext) {
  __webpack_require__("VqS+")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58cc4389"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_Pass_router_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_58cc4389_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_Pass_router_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UBJh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VqS+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W3pf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("QRbf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("cigS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pass_Pass_router__ = __webpack_require__("R0Ro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pass_Login__ = __webpack_require__("How1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pass_Register__ = __webpack_require__("AJQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home_home__ = __webpack_require__("LqM4");



// import Hello from '@/components/pass/Hello'



// import AppConsole from '@/components/app_console/index'
// import List from '@/components/app_console/list'
var AppConsole = function AppConsole() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "Qrbp"));
};
var List = function List() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "USYF"));
};
var App = function App() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "A9On"));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: '/www',
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_5__components_home_home__["a" /* default */],
    meta: {
      title: '信息复制网'
    }
  }, {
    path: '/app_console',
    name: 'console',
    component: AppConsole,
    meta: {
      title: '应用控制中心'
    },
    children: [{
      path: '',
      name: 'list',
      component: List,
      meta: {
        title: '应用控制中心'
      }
    }, {
      path: 'app/:id',
      name: 'app',
      component: App,
      meta: {
        title: '应用控制中心'
      }
    }]
  }, {
    path: '/auth',
    name: 'Pass',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pass_Pass_router__["a" /* default */],
    children: [
    // {
    //   path: 'hello',
    //   name: 'Hello',
    //   component: Hello,
    //
    // },
    {
      path: 'login',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_3__components_pass_Login__["a" /* default */],
      alias: '/login'
    }, {
      path: 'register',
      name: 'Register',
      component: __WEBPACK_IMPORTED_MODULE_4__components_pass_Register__["a" /* default */]
    }]
  }]
}));

/***/ }),

/***/ "ZAwa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c1Lm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      var self = this;
      if (this.global._PROJECT == 'shdq') {
        if (self.username != 'volvo' && self.username != 'ba' && self.username != 'test' && self.username != 'admin') {
          self.$message.error('用户名或密码错误');
          return;
        }
      }
      this.$http({
        method: 'post',
        url: (self.$route.query.app ? '/apps/' + self.$route.query.app : '') + '/iapi/user/login/',
        data: self.qs.stringify({ 'username': self.username, 'password': self.password }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        if (response.data.code != 0) {
          self.$message.error(response.data.message);
          return;
        }
        self.$message.success('登录成功');
        if (self.$route.query.next) window.location = self.$route.query.next;
      }, function (error) {
        _this.$message.error('用户名或密码错误');
      });
    },
    enterEvent: function enterEvent(e) {
      if (e.keyCode == 13) {
        this.login();
      }
    },
    register: function register() {
      var self = this;
      if (this.global._PROJECT == 'shdq') {
        // self.$message.error('已禁用');
        return;
      }
      this.$router.push({ name: 'Register', query: self.$route.query });
    }
  },
  created: function created() {
    document.addEventListener('keyup', this.enterEvent);
  },
  destroyed: function destroyed() {
    document.removeEventListener('keyup', this.enterEvent);
  }
});

/***/ }),

/***/ "d4Tv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('h1',{staticClass:"logo"},[_vm._v("登录")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"input-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text","placeholder":"请输入用户名"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"请输入密码"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"sub-btn",on:{"click":_vm.login}},[_vm._v("登 录")])]),_vm._v(" "),_c('div',{staticClass:"cut"}),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"des"},[_c('span',[_vm._v("没有账号？")]),_vm._v(" "),_c('span',{staticClass:"register",on:{"click":_vm.register}},[_vm._v("立即注册")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"second"},[_c('span',{staticClass:"forget"},[_vm._v("忘记密码")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mME3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nr7V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hidden)?_c('el-scrollbar',{staticClass:"noscroll-x",staticStyle:{"height":"100vh"}},[_c('div',{class:['home']},[_c('section',{staticClass:"section1"},[_c('div',{staticClass:"section-bg"}),_vm._v(" "),_c('div',{staticClass:"section-body"},[_c('div',{staticClass:"section-main"},[_c('h3',[_vm._v("拷客")]),_vm._v(" "),_c('p',{staticClass:"sub"},[_vm._v("是指把电脑、手机、PAD上感兴趣的信息收集起来，"),_c('br'),_vm._v("实现自己和分享好友的信息备忘和碎片式阅读")])])])]),_vm._v(" "),_c('section',{staticClass:"section2",attrs:{"id":"introduce"}},[_c('div',{staticClass:"section-title"},[_c('p',[_vm._v("网页操作： 从内容源复制文本，到拷客网站粘帖；从拷客网站直接上传文件")]),_vm._v(" "),_c('p',[_vm._v("电脑客户端操作：选择要收集的文本或文件，按CTRL+C+C完成上传")]),_vm._v(" "),_c('p',[_vm._v("手机客户端操作：选择要收集的文本或文件，长按屏幕，在弹出的菜单中选择共享（或分享、发送等）完成上传")])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('el-row',{staticStyle:{"width":"90%","margin":"0 auto"},attrs:{"gutter":30}},[_c('el-col',{attrs:{"lg":8,"md":12}},[_c('div',{staticClass:"servers-item bg-light"},[_c('i',{staticClass:"icon-social-dropbox"}),_vm._v(" "),_c('p',[_vm._v("多格式")]),_vm._v(" "),_c('p',{staticClass:"content"},[_vm._v("格式文本、网页、图形、表格、音视频等")])]),_vm._v(" "),_c('div',{staticClass:"tail"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":8,"md":12}},[_c('div',{staticClass:"servers-item bg-primary"},[_c('i',{staticClass:"icon-globe"}),_vm._v(" "),_c('p',[_vm._v("多形态")]),_vm._v(" "),_c('p',{staticClass:"content"},[_vm._v("文本、文件")])]),_vm._v(" "),_c('div',{staticClass:"tail"})]),_vm._v(" "),_c('el-col',{attrs:{"lg":8,"md":12}},[_c('div',{staticClass:"servers-item bg-light"},[_c('i',{staticClass:"icon-layers"}),_vm._v(" "),_c('p',[_vm._v("多载体")]),_vm._v(" "),_c('p',{staticClass:"content"},[_vm._v("WORD、EXCEL、邮件、QQ、网页、资源管理器等")])]),_vm._v(" "),_c('div',{staticClass:"tail"})])],1)],1)]),_vm._v(" "),_c('section',{staticClass:"section3",attrs:{"id":"case"}},[_c('div',{staticClass:"section-title"},[_c('h3',{},[_vm._v("案例介绍")])]),_vm._v(" "),_c('div',{staticClass:"power-item-wrap"},[_c('div',{staticClass:"container"},[_c('el-row',{staticClass:"dis-flex"},[_c('el-col',{staticClass:"h-v-center",attrs:{"lg":10}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-title"},[_vm._v("手机客户端")]),_vm._v(" "),_c('div',{staticClass:"spliter-wrap"},[_c('div',{staticClass:"spliter"})]),_vm._v(" "),_c('p',{staticClass:"introduce"},[_vm._v("通过拷客把手机上的照片、录音、录像、网页、短信、邮件等内容”收藏””分享”（有免费的短信提醒），好友对分享的内容评论或分享给其它好友\n                    ")])])]),_vm._v(" "),_c('el-col',{attrs:{"lg":14}},[_c('img',{staticStyle:{"width":"500px","height":"400px"},attrs:{"src":"/static/img/home/case1bak.png"}})])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"power-item-wrap"},[_c('div',{staticClass:"container"},[_c('el-row',{staticClass:"dis-flex"},[_c('el-col',{attrs:{"lg":14}},[_c('img',{staticStyle:{"width":"600px","height":"350px"},attrs:{"src":"/static/img/home/case2bak.png"}})]),_vm._v(" "),_c('el-col',{staticClass:"h-v-center",attrs:{"lg":10}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-title"},[_vm._v("Web版")]),_vm._v(" "),_c('div',{staticClass:"spliter-wrap rotate"},[_c('div',{staticClass:"spliter"})]),_vm._v(" "),_c('p',{staticClass:"introduce"},[_vm._v("如果用户不是智能机，可以使用web版，支持任何电脑和手机的操作系统、支持低端电脑和手机"),_c('br')])])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"power-item-wrap"},[_c('div',{staticClass:"container"},[_c('el-row',{staticClass:"dis-flex"},[_c('el-col',{staticClass:"h-v-center",attrs:{"lg":10}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-title"},[_vm._v("IPTV拷客是集浏览、收藏、分享为一体的一云多屏交互类应用")]),_vm._v(" "),_c('div',{staticClass:"spliter-wrap"},[_c('div',{staticClass:"spliter"})]),_vm._v(" "),_c('p',{staticClass:"introduce"},[_vm._v("IPTV用户，可以通过IPTV拷客的手机、PC客户端，收藏自己喜欢的照片、音视频，然后在TV端浏览，同时也允许经过授权的好友通过IPTV拷客的PC客户端、手机客户端将富媒体信息分享给IPTV拷客用户。\n                    ")])])]),_vm._v(" "),_c('el-col',{attrs:{"lg":14}},[_c('img',{staticStyle:{"width":"600px","height":"350px"},attrs:{"src":"/static/img/home/case3bak.png"}})])],1)],1)])]),_vm._v(" "),_c('footer',{staticClass:"h-v-center",attrs:{"id":"footer"}},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v("京ICP备11038383号-1")]),_vm._v(" "),_c('span',[_vm._v("地址：北京市昌平区立汤路龙德紫金 326")]),_vm._v(" "),_c('span',[_vm._v("联系方式：13701171932")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "uxEr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vUyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yfl/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("HVJf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {
      scrolling: false,
      activeStep: 0,
      interval: false,
      steps: [{
        icon: 'fa fa-database',
        title: '打包生成',
        content: '一键五端：安卓、IOS、手机网页、PC网站、安卓电视端'
      }, {
        icon: 'fa fa-area-chart',
        title: '录入和设置',
        content: '根据需要建立分类、添加商品、设置功能'
      }, {
        icon: 'fa fa-newspaper-o',
        title: '自定义UI',
        content: '动态的界面：首页、宣传页、中间过渡页\n' + '动态的导航：左栏、底栏、右栏\n' + '动态的列表样式：图文、卡片、文字、自定义\n' + '动态的内容展现模板：新闻、混排、电商、表单、视频、图集等等\n'
      }, {
        icon: 'fa fa-paper-plane-o',
        title: '权限设置',
        content: '登录权限——针对需要封闭的客户圈子提供登陆控制权限\n' + '查看权限——针对不同权限的客户提供不同能力，彰显VIP的特权\n' + '后台权限——针对不同连锁店，不同技能的人提供不同权限，便于整体管理'
      }]
    };
  },

  computed: {
    hidden: function hidden() {
      return this.global._PROJECT == 'shdq';
    }
  },
  methods: {
    HandleLogoClick: function HandleLogoClick() {
      window.location.reload();
    },
    skip: function skip(url) {
      location.href = url;
    },
    handleScroll: function handleScroll(e) {
      var scrollTop = e.target.scrollTop;
      var vh = this.$el.querySelector('.el-scrollbar__wrap').clientHeight;
      if (scrollTop > 0) {
        this.scrolling = true;
      } else {
        this.scrolling = false;
      }
      if (scrollTop <= vh) this.$el.querySelector('.section-bg').style.transform = 'translateY(-' + e.target.scrollTop / 6 + 'px)';
      if (scrollTop > this.$el.querySelector('.section5').offsetTop - vh) {
        if (!this.interval) {
          this.interval = this.getInterval();
        }
      } else {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = false;
        }
      }
    },
    start: function start() {
      this.$router.push({ name: 'Login' });
    },
    getInterval: function getInterval() {
      var _this = this;

      return setInterval(function () {
        if (_this.activeStep < 3) {
          _this.activeStep++;
        } else {
          _this.activeStep = 0;
        }
      }, 3000);
    }
  },
  mounted: function mounted() {
    if (!this.hidden) this.$el.querySelector('.el-scrollbar__wrap').addEventListener('scroll', this.handleScroll);
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b1fe09050503aab52b22.js